"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _themeUi = require("theme-ui");
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("../../../../Layout/Box"));
var _Group = require("../../Group");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

/** @jsx jsx */
var SVG = function SVG(props) {
  return (0, _themeUi.jsx)(_Box.default, (0, _tslib.__assign)({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentcolor"
  }, props));
};
var RadioChecked = function RadioChecked(props) {
  return (0, _themeUi.jsx)(SVG, (0, _tslib.__assign)({}, props), (0, _themeUi.jsx)("path", {
    d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
};
var RadioUnchecked = function RadioUnchecked(props) {
  return (0, _themeUi.jsx)(SVG, (0, _tslib.__assign)({}, props), (0, _themeUi.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
};
var RadioIcon = function RadioIcon(props) {
  return (0, _themeUi.jsx)(_react.default.Fragment, null, (0, _themeUi.jsx)(RadioChecked, (0, _tslib.__assign)({}, props, {
    __css: {
      display: 'none',
      // tslint:disable-next-line:no-duplicate-string
      'input:checked ~ &': {
        display: 'block'
      }
    }
  })), (0, _themeUi.jsx)(RadioUnchecked, (0, _tslib.__assign)({}, props, {
    __css: {
      display: 'block',
      'input:checked ~ &': {
        display: 'none'
      }
    }
  })));
};
var Radio = _react.default.forwardRef(function (_a, ref) {
  var field = _a.field,
    sx = _a.sx,
    _b = _a.variant,
    variant = _b === void 0 ? 'radio' : _b,
    props = (0, _tslib.__rest)(_a, ["field", "sx", "variant"]);
  return (0, _themeUi.jsx)(_Box.default, {
    sx: {
      ':focus-within': {
        outline: '1px dotted gray',
        outlineOffset: '2px'
      }
    }
  }, (0, _themeUi.jsx)(_Box.default, (0, _tslib.__assign)({
    ref: ref,
    as: "input"
  }, props, field, {
    type: "radio",
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: 1,
      width: sx ? sx.width : '24px',
      height: sx ? sx.height : '24px',
      overflow: 'hidden'
    },
    value: props.value
  })), (0, _themeUi.jsx)(_Box.default, {
    as: RadioIcon,
    "aria-hidden": "true",
    variant: variant,
    sx: sx,
    __css: {
      cursor: 'pointer',
      mr: 2,
      borderRadius: 9999,
      width: '24px',
      height: '24px',
      color: 'gray',
      'input:checked ~ &': {
        color: 'primary'
      },
      'input:focus ~ &': {
        color: 'primary',
        bg: 'highlight'
      }
    }
  }));
});
var RadioInput = function RadioInput(_a) {
  var defaultChecked = _a.defaultChecked,
    field = _a.field,
    id = _a.id,
    label = _a.label,
    name = _a.name,
    value = _a.value,
    hint = _a.hint,
    props = (0, _tslib.__rest)(_a, ["defaultChecked", "field", "id", "label", "name", "value", "hint"]);
  var isInGroup = (0, _react.useContext)(_Group.GroupContext).inGroup;
  var inputName = isInGroup ? (0, _react.useContext)(_Group.GroupContext).name : field && field.name || name;
  return (0, _themeUi.jsx)(Radio, (0, _tslib.__assign)({
    defaultChecked: defaultChecked,
    id: id
  }, field, {
    name: inputName,
    value: field && field.value || value || id
  }, props));
};
RadioInput.displayName = 'RadioInput';
RadioInput.defaultProps = {
  defaultChecked: false
};
var _default = RadioInput;
exports.default = _default;